export function mbToGb(mb: number) {
  return mb * 0.0009765625;
}
export function gbToMb(gb: number) {
  return gb / 0.0009765625;
}
